export default __webpack_public_path__ + "2ed3d08add12ca69431ae670e47b0a3c.png";